export const gotoHomeTextStyles = {
    textDecoration: 'underline',
    color: 'button.blue'

}